"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValidLocale = exports.LOCALES = exports.DEFAULT_LOCALE = void 0;
var LOCALES = ["zh-cn", "zh-hk", "zh-tw", "zh-hk", "ja-jp", "vi-vn", "ko-kr", "th-th", "en-gb", "id-id", "ms-my"];
exports.LOCALES = LOCALES;
var DEFAULT_LOCALE = 'en-gb';
exports.DEFAULT_LOCALE = DEFAULT_LOCALE;

var getValidLocale = function getValidLocale(locale) {
  if (LOCALES.includes(locale)) {
    return locale;
  }

  return DEFAULT_LOCALE;
};

exports.getValidLocale = getValidLocale;